import * as React from 'react'
import {FC} from 'react'
import {Row, Col} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import Button from 'antd/lib/button'
import 'antd/lib/button/style'
import ArrowLeftOutlined from '@ant-design/icons/lib/icons/ArrowLeftOutlined'
import ArrowRightOutlined from '@ant-design/icons/lib/icons/ArrowRightOutlined'
import {COMPONENT_SIZE} from '../../constants'
import './index.less'
import useTransitionForStepChanging from '../../../../../common/hooks/use-transition-for-step-changing'

export interface ControlBlockPropsInterface {
    currentStep: number
    onNextClick: (e) => void
    onPrevClick: () => void
    nextDisabled: boolean
}

const headerNodeId = 'calc-header'
const nextText = ['Далее', 'Оформить', 'Отправить', 'Новый расчёт']

const ControlBlock: FC<ControlBlockPropsInterface> = ({
    currentStep,
    onPrevClick,
    onNextClick,
    nextDisabled,
}) => {
    useTransitionForStepChanging(currentStep, headerNodeId)

    return (
        <Row gutter={{sm: 8, md: 16, xl: 24}} className={'e-control-block__container'}>
            <Col xs={12} sm={12}>
                {currentStep > 0 ? (
                    <Button
                        className={'e-control-block__button'}
                        icon={<ArrowLeftOutlined />}
                        size={COMPONENT_SIZE}
                        onClick={onPrevClick}
                    >
                        Назад
                    </Button>
                ) : null}
            </Col>
            <Col xs={12} sm={12}>
                <Button
                    className={'e-control-block__button'}
                    type={'primary'}
                    size={COMPONENT_SIZE}
                    onClick={onNextClick}
                    disabled={nextDisabled}
                >
                    {nextText[currentStep]} <ArrowRightOutlined />
                </Button>
            </Col>
        </Row>
    )
}

export default ControlBlock
